import React from 'react';
import LegalLayout from '../containers/Legal/LegalLayout';

const Terms = () => (
  <LegalLayout title="Terms & Conditions" updated="June 26, 2026">
    <p className="legal-intro">
      These Terms &amp; Conditions ("Terms") govern your use of the website and the auto-detailing
      services provided by <strong>J &amp; G Detailing LLC</strong> ("J &amp; G Detailing," "we,"
      "us," or "our"). By booking an appointment or using our website, you agree to these Terms.
    </p>

    <h2>1. Services</h2>
    <p>
      J &amp; G Detailing provides vehicle cleaning and detailing services. Service descriptions,
      packages, and pricing shown on our website are estimates and may vary based on the size,
      condition, and type of your vehicle. Final pricing is confirmed before work begins.
    </p>

    <h2>2. Booking &amp; Appointments</h2>
    <ul>
      <li>Appointments can be requested through our online booking page and are confirmed by our team.</li>
      <li>Booked times are reserved for you. We are closed on Saturdays and Sundays.</li>
      <li>We may contact you by phone, text message, or email to confirm, reschedule, or follow up on your appointment.</li>
      <li>Please ensure the information you provide (name, phone number, vehicle details) is accurate.</li>
    </ul>

    <h2>3. Cancellations &amp; No-Shows</h2>
    <p>
      We ask that you give us reasonable notice if you need to cancel or reschedule. Repeated
      no-shows or last-minute cancellations may affect future bookings. If you booked online, you
      may reply to your confirmation message or call us to cancel.
    </p>

    <h2>4. Payment</h2>
    <p>
      Payment is due upon completion of services unless otherwise agreed in writing. We accept the
      payment methods communicated at the time of service. Prices are subject to change without notice.
    </p>

    <h2>5. Vehicle Condition &amp; Personal Belongings</h2>
    <ul>
      <li>Please remove all personal belongings and valuables before your appointment. We are not responsible for lost, damaged, or stolen items left in the vehicle.</li>
      <li>We are not liable for pre-existing damage, wear, or defects (including but not limited to paint chips, scratches, stains, mechanical issues, or aftermarket modifications).</li>
      <li>Certain conditions (e.g., heavy stains, pet hair, mold, or excessive soiling) may require additional time or cost, which we will discuss with you.</li>
    </ul>

    <h2>6. Satisfaction</h2>
    <p>
      Your satisfaction matters to us. If you are not satisfied with a service, please notify us
      within 48 hours so we can make it right. Remedies are at our reasonable discretion and may
      include re-performing the affected service.
    </p>

    <h2>7. Limitation of Liability</h2>
    <p>
      To the fullest extent permitted by law, J &amp; G Detailing LLC shall not be liable for any
      indirect, incidental, or consequential damages arising from our services or your use of this
      website. Our total liability for any claim shall not exceed the amount paid for the specific
      service giving rise to the claim.
    </p>

    <h2>8. Text Messaging</h2>
    <p>
      By providing your phone number and opting in, you consent to receive booking-related text
      messages (such as confirmations and reminders). Message and data rates may apply. You can opt
      out at any time by replying STOP. See our <a href="/privacy">Privacy Policy</a> for details.
    </p>

    <h2>9. Website Use</h2>
    <p>
      The content on this website is provided for general information. You agree not to misuse the
      site, attempt to gain unauthorized access, or interfere with its operation.
    </p>

    <h2>10. Changes to These Terms</h2>
    <p>
      We may update these Terms from time to time. Changes are effective when posted to this page,
      with the "Last updated" date revised accordingly.
    </p>

    <h2>11. Contact Us</h2>
    <p>
      Questions about these Terms? Contact us at{' '}
      <a href="mailto:contact@jgdetailingllc.com">contact@jgdetailingllc.com</a> or call (763) 710-9136.
      <br />J &amp; G Detailing LLC · 701 Decatur Ave N, Suite 204, Golden Valley, MN 55427.
    </p>

    <p className="legal-note">
      This page is provided as a general template and does not constitute legal advice. We recommend
      having it reviewed by a qualified attorney to ensure it fits your business and complies with
      applicable laws.
    </p>
  </LegalLayout>
);

export default Terms;
